// extracted by css-extract-rspack-plugin
export default {"logoContainer":"profile-logo-module__logoContainer___oA9Pg","logoImage":"profile-logo-module__logoImage___Z9blm","logoWrapper":"profile-logo-module__logoWrapper___dKe7I"};